module.exports = __webpack_public_path__ + "static/media/26UNRWA9.19f3c151.jpg";